import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/icon.css'


import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css
import '@/assets/iconfont/iconfont.css'
import App from './App'
import router from './router'
import store from './store'
import { setCookie, getCookie } from "@/utils/support";
import '@/icons' // icon
import '@/permission' // permission control
import Print from 'vue-print-nb'
Vue.use(Print);  //注册
Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.config.productionTip = false
let LN  = getCookie("language") ;
if( typeof(LN) == 'undefined' ){
	setCookie("language", 0, 15);
}


new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js